import { doorClient, ImResponse, resolve } from 'services/api';

export function getWabaList() {
  return resolve(
    doorClient.get<
      ImResponse<{
        accounts: Aide.Waba[];
      }>
    >('/oversea-wa-biz-home/waba/list'),
  );
}

export function getGroupList() {
  return resolve(
    doorClient.get<ImResponse<string[]>>('/oversea-wa-biz-home/msgTemplate/groupList'),
  );
}

export function createGroup(group: string) {
  return doorClient.post('/oversea-wa-biz-home/msgTemplate/group', { group });
}

export function getTemplateList() {
  return resolve(
    doorClient.get<
      ImResponse<{
        details: Aide.WhatsAppTemplateGroup[];
      }>
    >('/oversea-wa-biz-home/msgTemplate/list', {
      params: {
        pageNum: 1,
        pageSize: 999,
      },
    }),
  ).then(({ details, ...others }) => {
    return {
      ...others,
      details: details.filter(({ template }) => template.length),
    };
  });
}

export function createTemplate(
  body: Omit<Aide.WhatsAppTemplateGroup, 'template'> & {
    details: Omit<Aide.WhatsAppTemplate, 'id' | 'templateId'>;
  },
) {
  return doorClient.post('/oversea-wa-biz-home/msgTemplate', body);
}

export function updateTemplate(body: Aide.WhatsAppTemplateGroup) {
  return doorClient.post('/oversea-wa-biz-home/msgTemplate', body);
}

export function updateTemplateGroup(
  body: Pick<Aide.WhatsAppTemplateGroup, 'name' | 'group' | 'status' | 'show'> & {
    wabaId: string;
  },
) {
  return doorClient.put('/oversea-wa-biz-home/msgTemplate', body);
}

export function deleteTemplate(params: { name: string; wabaId: string }) {
  return doorClient.delete('/oversea-wa-biz-home/msgTemplate', { params });
}

export function updateWaFile(file: any) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('sendToWa', 'true');
  return resolve(
    doorClient.post<
      ImResponse<{
        url: string;
        localUrl: string;
        thumbUrl: string;
      }>
    >('/oversea-wa-biz-home/uploadFile', formData),
  );
}
